import { Routes } from '@angular/router';

export const routes: Routes = [
  {
    path: '',
    loadComponent: () =>
      import('./pages/home/home.component').then((c) => c.HomeComponent),
  },
  {
    path: 'save-on-registration',
    loadComponent: () =>
      import(
        './pages/save-on-registration/save-on-registration.component'
      ).then((c) => c.SaveOnRegistrationComponent),
  },
  {
    path: 'fuel-tax-credit',
    loadComponent: () =>
      import('./pages/fuel-tax-credit/fuel-tax-credit.component').then(
        (c) => c.FuelTaxCreditComponent
      ),
  },
  {
    path: 'help-center',
    loadComponent: () =>
      import('./pages/help-center/help-center.component').then(
        (c) => c.HelpCenterComponent
      ),
  },
  {
    path: 'terms-and-conditions',
    loadComponent: () =>
      import(
        './pages/terms-and-conditions/terms-and-conditions.component'
      ).then((c) => c.TermsAndConditionsComponent),
  },
  {
    path: 'privacy-policy',
    loadComponent: () =>
      import('./pages/privacy-policy/privacy-policy.component').then(
        (c) => c.PrivacyPolicyComponent
      ),
  },
  {
    path: 'telematics-device-installation',
    loadComponent: () =>
      import(
        './pages/telematics-device-installation/telematics-device-installation.component'
      ).then((c) => c.TelematicsDeviceInstallationComponent),
  },
  {
    path: 'check-your-vehicles-compatibility',
    loadComponent: () =>
      import(
        './pages/check-your-vehicles-compatibility/check-your-vehicles-compatibility.component'
      ).then((c) => c.CheckYourVehiclesCompatibilityComponent),
  },
  {
    path: '**',
    loadComponent: () =>
      import('./pages/not-found/not-found.component').then(
        (c) => c.NotFoundComponent
      ),
  },
];
